import { handleActions } from 'redux-actions'

import * as actions from './actions'

const initialState = {
  status: 'init',
  error: '',
  user: {},
}

const reducer = handleActions({
  [actions.fetchUserData.START]: (state) => ({
    ...state,
    status: 'pending'
  }),
  [actions.fetchUserData.FAILURE]: (state, action) => ({
    ...state,
    status: 'failure',
    error: action.payload.error
  }),
  [actions.fetchUserData.SUCCESS]: (state, action) => ({
    ...state,
    status: 'success',
    user: action.payload.user
  })
}, initialState)

export default reducer